import { useEffect } from 'react';
import { useDeviceDetection } from '@/hooks/use-mobile';
import { useResponsiveLayout } from '@/hooks/useResponsiveLayout';
import { toast } from 'sonner';

/**
 * Componente que muestra un mensaje de bienvenida
 * personalizado según el dispositivo detectado
 */
export const DeviceDetectionToast = () => {
  const { isIOS, isAndroid, isStandalone } = useDeviceDetection();
  const layout = useResponsiveLayout();

  useEffect(() => {
    // Solo mostrar una vez por sesión
    const hasShownToast = sessionStorage.getItem('device-toast-shown');
    if (hasShownToast) return;

    const showDeviceInfo = () => {
      let deviceName = 'desktop';
      let icon = '💻';
      
      if (layout.isMobile) {
        if (isIOS) {
          deviceName = 'iPhone';
          icon = '📱';
        } else if (isAndroid) {
          deviceName = 'Android';
          icon = '📱';
        } else {
          deviceName = 'móvil';
          icon = '📱';
        }
      } else if (layout.isTablet) {
        if (isIOS) {
          deviceName = 'iPad';
          icon = '📱';
        } else {
          deviceName = 'tablet';
          icon = '📱';
        }
      }

      const mode = isStandalone ? 'instalada' : 'navegador';
      
      console.log('📱 [Device Info]', {
        device: deviceName,
        mode,
        screenSize: layout.screenSize,
        isStandalone,
      });

      // Solo mostrar en desarrollo o primera vez
      if (process.env.NODE_ENV === 'development') {
        toast.info(
          `${icon} Optimizado para ${deviceName} (${mode})`,
          {
            duration: 3000,
            description: `Pantalla: ${layout.screenSize}`,
          }
        );
      }

      sessionStorage.setItem('device-toast-shown', 'true');
    };

    // Delay para no interferir con otros mensajes de inicio
    setTimeout(showDeviceInfo, 1000);
  }, [isIOS, isAndroid, isStandalone, layout]);

  return null;
};
